;(function () {
  angular
    .module('contrast.virtual-patch')
    .controller(
      'VirtualPatchCtrl',
      function VirtualPatchCtrl(
        $scope,
        $timeout,
        virtualPatchService,
        LanguagesService,
        PromiseService,
        SERVER_ENVIRONMENTS
      ) {
        'ngInject'

        var _searchKeywords
        var _lastSearch

        angular.extend($scope, {
          loadByScroll: loadByScroll,
          order: order,
          changeEnabled: changeEnabled,
          openDelete: openDelete,
          quickFilterSelect: quickFilterSelect,
          getLangaugeDisplayValue: getLangaugeDisplayValue
        })

        function init() {
          _initDefaults()
          $scope.data.busyPromise = _getQuickFilters().then(_newSearch)
        }

        function _initDefaults() {
          _searchKeywords = ''
          angular.extend($scope, {
            environment: SERVER_ENVIRONMENTS,
            data: {
              numPerLoad: 10,
              loadPromise: null,
              busy: true,
              patches: [],
              count: 0,
              row: 'name',
              searchKeywords: searchKeywords
            },

            quickFilters: [],
            selectedQuickFilter: {
              name: 'All',
              filterType: 'ALL',
              count: '?'
            }
          })
        }

        function loadByScroll() {
          if (
            $scope.data.patches.length === $scope.data.count ||
            $scope.data.busy
          ) {
            return
          }

          return ($scope.data.scrollPromise = _getPatches(
            $scope.numPerLoad,
            $scope.data.patches.length
          ))
        }

        function order(rowName) {
          if ($scope.data.row === rowName) {
            return
          }

          $scope.data.row = rowName

          return ($scope.data.busyPromise = refreshData(false))
        }

        function searchKeywords(newSearchKeywords) {
          if (!arguments.length) {
            return _searchKeywords
          }

          if (newSearchKeywords !== _searchKeywords) {
            _searchKeywords = newSearchKeywords
          }

          refreshData()

          return _searchKeywords
        }

        function quickFilterSelect(filter) {
          $scope.selectedQuickFilter = filter
          return ($scope.data.busyPromise = refreshData(false))
        }

        function refreshData(reloadQuickFilters) {
          var promise
          if (angular.isUndefined(reloadQuickFilters) || reloadQuickFilters) {
            promise = _getQuickFilters()
          }

          if (promise) {
            return promise.then(_newSearch)
          }

          return _newSearch()
        }

        function _newSearch() {
          $scope.data.patches = []
          return _getPatches($scope.data.numPerLoad, 0)
        }

        function _getPatches(limit, offset) {
          if (_lastSearch) {
            PromiseService.cancelPromise(_lastSearch)
          }

          var filters = {
            limit: limit,
            offset: offset,
            sort: $scope.data.row,
            filterText: searchKeywords(),
            quickFilter: $scope.selectedQuickFilter.filterType,
            expand: 'languages'
          }

          $scope.data.busy = true
          return ($scope.data.loadPromise = virtualPatchService
            .getVirtualPatches(filters)
            .then(function (data) {
              $scope.data.count = data.count
              $scope.data.patches = $scope.data.patches.concat(data.patches)

              $timeout(function () {
                $scope.$emit('triggerScrollCheck')
              })
            })
            .finally(function () {
              $scope.data.busy = false
            }))
        }

        function _getQuickFilters() {
          var filters = {
            filterText: searchKeywords()
          }

          return virtualPatchService
            .getQuickFilters(filters)
            .then(function (filters) {
              $scope.quickFilters = filters

              $scope.selectedQuickFilter = $scope.quickFilters.find(function (
                filter
              ) {
                return (
                  filter.filterType === $scope.selectedQuickFilter.filterType
                )
              })
            })
        }

        function changeEnabled(patch, environment) {
          updatingEnvironment(environment, true)
          return virtualPatchService
            .toggleEnabled(patch.uuid, environment)
            .finally(function () {
              updatingEnvironment(environment, false)
            })
        }

        function updatingEnvironment(environment, value) {
          // TODO: CONTRAST-18297
          // eslint-disable-next-line default-case
          switch (environment) {
            case SERVER_ENVIRONMENTS.DEV.id:
              $scope.updatingEnabledDev = value
              break
            case SERVER_ENVIRONMENTS.QA.id:
              $scope.updatingEnabledQA = value
              break
            case SERVER_ENVIRONMENTS.PROD.id:
              $scope.updatingEnabledProd = value
              break
          }
        }

        function openDelete(patch) {
          return virtualPatchService.openDeleteModal(patch).then(init)
        }

        function getLangaugeDisplayValue(language) {
          return LanguagesService.getLanguage(language).display
        }

        init()
      }
    )
})()
